// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-image[data-v-4f3f33c4] {\n  position: relative;\n}\n.component-image .inner-bg[data-v-4f3f33c4] {\n  width: 100%;\n  height: 100%;\n}\n.component-image .c-loader[data-v-4f3f33c4] {\n  margin-top: -9px;\n  margin-left: -9px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
